const m = require('minthril');
const { component } = require('../../../component');
const { Breadcrumbs } = require('../../../components/breadcrumbs');

const approaches = [
  [
    'Spache',
    '/how-it-works',
    'Visitors and crawlers',
    'Spache renders and serves cached routes, then refreshes them using configured cache and validation behavior.',
    'Configure your app origin, routes, cache behavior, and domain.'
  ],
  [
    'Astro',
    '/docs/comparisons/astro',
    'Visitors and crawlers',
    'Render at build time or on demand, then configure how generated or server-rendered pages stay current.',
    'Choose rendering modes, islands, data loading, deployment, and content freshness.'
  ],
  [
    'Next.js',
    '/docs/comparisons/nextjs',
    'Visitors and crawlers',
    'Render in the build or server, with freshness controlled by the app’s caching and revalidation strategy.',
    'Build the server-rendered app and choose route, data-cache, and revalidation behavior.'
  ],
  [
    'react-snap',
    '/docs/comparisons/react-snap',
    'Visitors and crawlers',
    'Render routes in a headless browser during the build and deploy the generated HTML files.',
    'Run the browser crawl in CI, ensure routes are found, publish snapshots, and regenerate them when content changes.'
  ],
  [
    'Prerender.io',
    '/docs/comparisons/prerender',
    'Crawlers; visitors use the normal site path',
    'Render crawler requests on cache misses and serve cached HTML to later crawler requests.',
    'Integrate crawler detection and routing, and configure cache expiration or recaching.'
  ]
];

const ComparisonsPage = component(() => ({
  view: () => {
    const approachRows = approaches.map(([name, href, audience, rendering, responsibility]) => m('tr', [
      m('th', m('a', { href }, name)),
      m('td', audience),
      m('td', rendering),
      m('td', responsibility)
    ]));

    return m('section.panel.docs-page comparisons-page', [
      m(Breadcrumbs, {
        items: [
          { label: 'Docs', href: '/docs' },
          { label: 'Comparisons' }
        ]
      }),
      m('h2', 'Compare rendering approaches'),
      m('p',
        'These approaches can all make a JavaScript app’s content available as HTML. The useful comparison is who ' +
      'receives that HTML, where rendering happens, and which parts of freshness and delivery your team operates.'
      ),
      m('div.comparisons__table-wrap', [
        m('table.comparisons__table', [
          m('thead', m('tr', [
            m('th', 'Approach'),
            m('th', 'Who gets prepared HTML?'),
            m('th', 'Rendering and freshness'),
            m('th', 'What your team owns')
          ])),
          m('tbody', approachRows)
        ])
      ]),
      m('p', [
        'Open a comparison for a closer look at the trade-offs: ',
        m('a', { href: '/docs/comparisons/astro' }, 'Astro'), ', ',
        m('a', { href: '/docs/comparisons/nextjs' }, 'Next.js'), ', ',
        m('a', { href: '/docs/comparisons/react-snap' }, 'react-snap'), ', and ',
        m('a', { href: '/docs/comparisons/prerender' }, 'Prerender.io'),
        '.'
      ]),
      m('section.docs-page__article.comparisons__case-study', [
        m('div.comparisons__case-study-copy', [
          m('h3', 'Mid Engine Co: a real Spache case study'),
          m('p', [
            'Visit ',
            m('a', {
              href: 'https://midengineco.com',
              target: '_blank',
              rel: 'noopener noreferrer'
            }, 'midengineco.com'),
            ', a custom storefront backed by Shopify.'
          ]),
          m('p',
            'It was built as a plain single-page app with Mithril. During development, no server-side rendering ' +
          'work or SSR framework was added; the app loads its product data in the browser, manages each visitor’s ' +
          'cart there, and sends checkout to Shopify.'
          ),
          m('p',
            'The existing Render-hosted app was configured as the Spache origin, then its public domain was connected ' +
          'and pointed through Spache. Spache renders and serves prepared product pages, while the visitor’s SPA ' +
          'still starts normally. Public JSON GET responses are captured automatically for startup replay; the ' +
          'visitor’s cart remains their own live browser session. No SSR conversion or separate static HTML ' +
          'publishing pipeline was needed.'
          )
        ]),
        m('figure.comparisons__live-screenshot', [
          m('img', {
            src: 'https://spache.online/api/sites/ncGqZdfo3BMZ1GFLQP66/routes/d66ca189b1e76ae5fba6960e246b467cb759c0bce2093f634ab3cd4a34675c2c/screenshot.jpg',
            alt: 'Current Spache-generated screenshot of Mid Engine Co’s products page',
            loading: 'lazy',
            decoding: 'async'
          }),
          m('figcaption', 'Live Spache screenshot of the Mid Engine Co products route.')
        ])
      ])
    ]);
  }
}));

module.exports = { ComparisonsPage };
